import { withinRange } from "./getSelectedState.js";
const getHoverState = ({
  date,
  isRange,
  selected,
  hoverDate
}) => {
  if (!date || !isRange || !hoverDate || !(selected != null && selected[0]) && !(selected != null && selected[1]))
    return;
  const [rangeStart, rangeEnd] = selected;
  let hoverRange = [void 0, void 0];
  if (rangeStart && rangeEnd) {
    if (rangeStart <= hoverDate && rangeEnd >= hoverDate)
      return;
    rangeStart > hoverDate ? hoverRange = [hoverDate, rangeEnd] : hoverRange = [rangeEnd, hoverDate];
  } else {
    const date2 = rangeStart || rangeEnd;
    if (date2 === hoverDate)
      return;
    hoverRange = date2 && date2 > hoverDate ? [hoverDate, date2] : [date2, hoverDate];
  }
  const [hoverRangeStart, hoverRangeEnd] = hoverRange;
  if (withinRange(date, [hoverRangeStart, hoverRangeEnd]))
    return "hover-range";
  if (date === hoverRangeStart)
    return "hover-range-start";
  if (date === hoverRangeEnd)
    return "hover-range-end";
};
export {
  getHoverState
};
//# sourceMappingURL=getHoverState.js.map
